import { _ as __assign } from '../../chunks/bundle-j5GfJ6DZ.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from '../../chunks/bundle-B5EHFFGW.js';
import '../../chunks/bundle-ZBp236Ey.js';
import '../../chunks/bundle-BjDPDV1u.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-idC_wVZi.js';
import '../../chunks/bundle-2OseAMr7.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-BlgLvEI8.js';
import '../../chunks/bundle-BSUtC3cw.js';
import '../../chunks/bundle-CnQtgeX8.js';
import '../../chunks/bundle-B7LMd75S.js';
import '../../chunks/bundle-CPQL3IZE.js';
import '../../chunks/bundle-dyq0aH11.js';
import '../../chunks/bundle-DloqDvm2.js';
import '../../chunks/bundle-BC1GKYVu.js';
import '../../chunks/bundle-C6g3HNED.js';
import '@sendbird/chat';
import '@sendbird/chat/groupChannel';
import '@sendbird/chat/openChannel';

var SuggestedMentionList = function (props) {
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props)));
};

export { SuggestedMentionList, SuggestedMentionList as default };
//# sourceMappingURL=SuggestedMentionList.js.map
